// extracted by mini-css-extract-plugin
export default {"summary":"CommendationAccordion_summary__sUwjD","list":"CommendationAccordion_list__-m+OA","icon":"CommendationAccordion_icon__TB9rc"};